export enum ApiEndpoints {
  REFRESH_TOKEN = "/auth/signin-refresh-token",
  SIGNIN = "/auth/signin",
  SIGNUP = "/auth/signup",
  ME = "/auth/me",

  // Company management endpoints (OWNER role)
  COMPANY = "/company",
  COMPANY_ADMIN_CREATE = "/company/admin/create",

  // Company Telegram endpoints
  COMPANY_TELEGRAM_TOKEN = "/company/telegram",
  COMPANY_TELEGRAM_TEST = "/company/telegram/test",

  // Company Users endpoints
  COMPANY_USERS = "/company/users",
  COMPANY_USERS_PRE_INVITE = "/company/users/pre-invite",
  COMPANY_USERS_INVITE = "/company/users/invite",
  COMPANY_USERS_INVITE_NEW = "/company/users/invite/new",
  COMPANY_USERS_INVITE_EXISTING = "/company/users/invite/existing",

  // Company Settings endpoints
  COMPANY_SETTINGS = "/company/settings",

  // Marketing endpoints
  MARKETING_JOIN_WHITELIST = "/marketing/join-whitelist",
  MARKETING_REQUEST_SUPPORT = "/marketing/request-support",

  // User endpoints
  USER = "/user",
  USER_CURRENT_COMPANY = "/user/current-company",
}
